export enum IExcludedCommodities {
  ALCOHOL = 'alcohol',
  BABY_FOOD = 'baby_food',
  COSMETIC = 'cosmetic',
  ELECTRONIC = 'electronic',
  GARMENT = 'garment',
  JEWELRY = 'jewelry',
  MEAT = 'meat',
  MEDICATION = 'medication',
  METAL = 'metal',
  SEAFOOD = 'seafood',
  TOBACCO = 'tobacco',
}

export const EXCLUDED_COMMODITIES_LABELS: Record<IExcludedCommodities, string> = {
  [IExcludedCommodities.ALCOHOL]: 'Alcohol',
  [IExcludedCommodities.BABY_FOOD]: 'Baby Food',
  [IExcludedCommodities.COSMETIC]: 'Cosmetics',
  [IExcludedCommodities.ELECTRONIC]: 'Electronics',
  [IExcludedCommodities.GARMENT]: 'Garments, Shoes, or Apparel',
  [IExcludedCommodities.JEWELRY]: 'Jewelry',
  [IExcludedCommodities.MEAT]: 'Meat',
  [IExcludedCommodities.MEDICATION]: 'Pharmaceuticals',
  [IExcludedCommodities.METAL]: 'Metals',
  [IExcludedCommodities.SEAFOOD]: 'Seafood/Shellfish',
  [IExcludedCommodities.TOBACCO]: 'Tobacco',
}
